const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Imported Content Manager Directive to display a list or table with tracks to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('imagePlaceholder', [function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      textkey: '=?',
      type: '=?'
    },
    template: require('../../templates/directives/image-placeholder.html'),
    controller: ['$scope', function($scope) {
      var self = this;
      self.text = $scope.textkey ? $scope.textkey : "There is nothing to appear here yet.";
      self.type = $scope.type ? $scope.type : "default";
     }],
    controllerAs: 'placeholder'
  };
}]);